(function () {
    angular
        .module('advancedapp')
        .directive('fadeIn', fadeIn);

    function fadeIn() {

        var directive = {
            link: link,
            restrict: 'A',

        };

        return directive;

        function link(scope, element, attrs) {

            function animationEndCallback(event) {
                this.removeEventListener('animationEnd', animationEndCallback);
                this.classList.remove('fadeInUp');
            }

            const angularObserver = new IntersectionObserver(fadeIn);
            const mediaCoverage = angular.element(element)[0];
            angularObserver.observe(mediaCoverage);

            function fadeIn(changes) {
                changes.forEach(change => {
                    if (change.intersectionRatio > 0) {
                        change.target.classList.add('fadeInUp');
                        change.target.addEventListener('animationend', animationEndCallback);
                    }
                });
            }
        }
    }
})();